import { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBook } from '@fortawesome/pro-solid-svg-icons/faBook'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { useTranslation } from 'react-i18next'
import { useLocation, useHistory } from 'react-router-dom'
import { Tabs } from 'antd'
import Wrapper from 'components/reusables/wrapper'
import { PathRoutes } from 'enum/routes'
import { Title, Description } from './styled'
import Roles from './roles'
import Users from './users'

const { TabPane } = Tabs

export const RolesAndPermissions = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const history = useHistory()
  const linkSupportCenter =
    'https://rankmi.odoo.com/knowledge/article#id=4963&cids=1'
  const prefix = 'configuration.rolesAndPermissions'
  const [activeTab, setActiveTab] = useState('')

  useEffect(() => {
    if (location.pathname.includes('/users')) {
      setActiveTab('users')
    } else {
      setActiveTab('roles')
    }
  }, [location.pathname])

  const handleTabChange = (key: string) => {
    if (key === 'users') {
      history.push(
        PathRoutes.ROLES_AND_PERMISSIONS_USERS.replace('/:roleId?', '')
      )
    } else {
      history.push(PathRoutes.ROLES_AND_PERMISSIONS)
    }
  }

  return (
    <Wrapper shadow={true}>
      <Title>
        {t(`${prefix}.title`)}
        <a href={linkSupportCenter} target="_blank">
          <FontAwesomeIcon icon={faBook} />
          {t(`${prefix}.linkSupportCenter`)}
        </a>
      </Title>
      <Description>
        <FontAwesomeIcon icon={faInfoCircle} />
        {t(`${prefix}.description`)}
      </Description>
      <Tabs activeKey={activeTab} onChange={handleTabChange} animated={false}>
        <TabPane tab="Roles" key="roles">
          <Roles />
        </TabPane>
        <TabPane tab="Usuarios" key="users">
          <Users />
        </TabPane>
      </Tabs>
    </Wrapper>
  )
}

export default RolesAndPermissions
